import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';
import { isEmpty } from 'lodash';
import { useIsMobile } from 'utils/hooks';
import Dialog from 'components/Ui/Dialog';
import { withPromo } from 'components/Promos';
import { findPromoContentByType } from 'components/Promos/content';
import { selectIsPartiallyMigrated } from 'containers/Authentication/selectors';
import MarketingPromotionDetails from './MarketingPromotionDetails';

const STORAGE_KEY = 'seenPromoDialogs';
const MAX_DAYS_TO_HIDE_SEEN_DIALOGS = 30;

const filterOutMigrationSpecific = (dialogs, isPartMig) => {
  const showToPartiallyMigrated = ['noticePartiallyMigrated'];

  if (isPartMig) return dialogs;

  return dialogs.filter(
    (dialog) => !showToPartiallyMigrated.includes(dialog.promoHandle),
  );
};

const getSeenDialogs = () => {
  const seenDialogsStore = localStorage.getItem(STORAGE_KEY) || '{}';
  return JSON.parse(seenDialogsStore);
};

const setDialogAsSeen = (handle) => {
  const seenDialogs = getSeenDialogs();
  seenDialogs[handle] = moment().toISOString(); // set value to today's date
  localStorage.setItem(STORAGE_KEY, JSON.stringify(seenDialogs));
};

const hasDialogBeenSeen = (handle) => {
  const seenDialog = getSeenDialogs()[handle];
  if (!seenDialog) return false;
  const daysSinceSeen = moment().diff(seenDialog, 'days');
  return daysSinceSeen < MAX_DAYS_TO_HIDE_SEEN_DIALOGS;
};

const MarketingPromotion = ({ brand, branch, promos }) => {
  const [dialog, setDialog] = useState();
  const isPartiallyMigrated = useSelector(selectIsPartiallyMigrated());
  const isMobile = useIsMobile();

  useEffect(() => {
    const foundDialogs = findPromoContentByType(promos, 'promoDialog');

    if (!foundDialogs.length) return;

    const filteredDialogs = filterOutMigrationSpecific(
      foundDialogs,
      isPartiallyMigrated,
    );

    const firstUnseen = filteredDialogs.filter(
      (fd) => !hasDialogBeenSeen(fd.promoHandle),
    )[0];

    if (!firstUnseen) return;

    setDialog(firstUnseen);
  }, [promos]);

  if (!dialog) return null;

  return (
    <>
      {!isEmpty(dialog) && (
        <Dialog
          size="medium"
          isAutoClose={false}
          isCloseIcon
          noPaddingContent
          open="true"
          fullScreen={isMobile}
          customStyle={isMobile ? '' : 'promo'}
        >
          <div data-tracking="promotion-modal">
            <MarketingPromotionDetails
              dialog={dialog}
              brand={brand}
              branch={branch}
              onView={() => setDialogAsSeen(dialog.promoHandle)}
            />
          </div>
        </Dialog>
      )}
    </>
  );
};

MarketingPromotion.propTypes = {
  brand: PropTypes.string,
  branch: PropTypes.string,
  promos: PropTypes.object,
};

export default withPromo()(MarketingPromotion);
